import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, model, output } from '@angular/core';

export type ToggleSwitchSize = 'S' | 'M' | 'L';

@Component({
  selector: 'app-toggle-switch-atom',
  templateUrl: './toggle-switch-atom.component.html',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'contents',
  },
})
export class ToggleSwitchAtomComponent {
  readonly checked = model(true);
  readonly disabled = input(false);
  readonly size = input<ToggleSwitchSize>('M');

  readonly checkedChange = output<boolean>();

  constructor() {}

  toggleValue(): void {
    if (this.disabled()) return;
    this.checked.set(!this.checked());
    this.checkedChange.emit(this.checked());
  }
}
